import React, { useEffect, useState } from "react";
import { _getCSRFTokenValue, _getBaseUrl, } from "../utils/helper";
import api from "../utils/api";

function AgendaForm() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [response, setResponse] = useState(null);
  const [fileName, setFileName] = useState("");
  const [mediaId, setMediaId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    doelgroep: [],
    wijken: [],
    type: [],
    transitieagenda: [],
  });

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchFilters = () => {
    api
      .get("/filterlistoptions")
      .then((res) => {
        setFilterOptions(res.data);
      })
      .catch(() => {
        console.error("Failed to fetch filter options");
      });
  };
  //image upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setFileName(file?.name || "");
    setImagePreview(URL.createObjectURL(file));
    setMediaId(null);

    if (!file) return;

    const uploadData = new FormData();
    uploadData.append("image", file);

    try {
      const res = await fetch("/api/upload_image", {
        method: "POST",
        body: uploadData,
      });

      const result = await res.json();

      console.log("Upload response:", result);

      if (res.ok && result.status === "success") {
        // Use the correct ID â€” media_id or file_id depending on your need
        setMediaId(result.file_id || result.media_id); // Adjust this based on your backend response
        setErrors((prev) => ({ ...prev, image: null }));
      } else {
        setErrors((prev) => ({
          ...prev,
          image: result.message || "Fout bij uploaden van afbeelding.",
        }));
      }
    } catch (err) {
      console.error("Image upload error:", err);
      setErrors((prev) => ({
        ...prev,
        image: "Afbeelding uploaden mislukt.",
      }));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setFileName("");
    setMediaId(null);
    document.getElementById("agendaImage").value = null; // clear input
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setResponse(null);

    const formData = new FormData(e.target);
    const formValues = {};

    for (const [key, value] of formData.entries()) {
      if (formValues[key]) {
        if (!Array.isArray(formValues[key])) {
          formValues[key] = [formValues[key]];
        }
        formValues[key].push(value);
      } else {
        formValues[key] = value;
      }
    }

    console.log("img", mediaId);

    // Attach uploaded media ID
    if (mediaId) {
      formValues["image"] = mediaId;
    }

    console.log("sub", formValues);

    try {
      const csrfToken = await _getCSRFTokenValue();

      const res = await fetch("/api/form_node_save", {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValues),
      });

      const data = await res.json();

      if (res.ok && data.status === "success") {
        setResponse({
          status: "success",
          message: `Formulier verzonden. Node ID: ${data.nid}`,
        });
        setShowSuccessModal(true);
        e.target.reset();
        setFileName("");
        setMediaId(null);
        setImagePreview(null);
      } else {
        setResponse({
          status: "error",
          message: data.message || "Er is iets misgegaan",
        });
        if (data.errors) setErrors(data.errors);
      }
    } catch (err) {
      console.error("Submit error", err);
      setResponse({
        status: "error",
        message: "Serverfout. Probeer opnieuw.",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <form id="agendaForm" onSubmit={handleSubmit} className="py-6 w-full md:w-2/3">
        {/* Title */}
        <div className="md:grid md:grid-cols-3 pb-4">
          <label htmlFor="agendaTitle" className="pr-4">Titel *</label>
          <div className="w-full col-span-2">
            <input type="text" name="title" id="agendaTitle" className="w-full border p-2" />
          </div>
          {errors.title && <div className="text-red-600 col-span-3">{errors.title}</div>}
        </div>

        {/* Summary */}
        <div className="md:grid md:grid-cols-3 pb-4">
          <label htmlFor="agendaSummary" className="pr-4">Summary</label>
          <div className="w-full col-span-2">
            <textarea name="summary" id="agendaSummary" rows="2" className="w-full border p-2"></textarea>
          </div>
        </div>

        {/* Body */}
        <div className="md:grid md:grid-cols-3 pb-4">
          <label htmlFor="agendaBody" className="pr-4">Tekst *</label>
          <div className="w-full col-span-2">
            <textarea name="body" id="agendaBody" rows="4" className="w-full border p-2"></textarea>
          </div>
          {errors.body && <div className="text-red-600 col-span-3">{errors.body}</div>}
        </div>


        {/* Image Upload */}
        <div className="md:grid md:grid-cols-3 py-4">
          <label htmlFor="agendaImage" className="pr-4">Afbeelding</label>

          <div className="w-full col-span-2 flex items-center gap-4">
            <div>
              {imagePreview && (
                <div className="relative max-w-xs">
                  <img
                    src={imagePreview}
                    alt="Voorbeeld"
                    className="w-full h-full object-cover"
                  />
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    className="hover:opacity-80"
                  >
                    <img
                      src={_getBaseUrl("src/assets/icons/icon-remove.svg", true)}
                      alt="Verwijder"
                      className="absolute top-1 -right-4 w-3 h-3"
                    />
                  </button>
                </div>
              )}
              <span className="text-sm text-gray-700">{fileName}</span>
            </div>

            <button
              type="button"
              onClick={() => document.getElementById("agendaImage").click()}
              className="text-base rounded-full py-3 px-5 border border-black cursor-pointer"
            >
              Upload afbeelding
            </button>
            <input
              type="file"
              name="actualimage"
              id="agendaImage"
              className="hidden w-fit"
              onChange={handleFileChange}
            />
          </div>
          {errors.image && <div className="text-red-600 col-span-3">{errors.image}</div>}
        </div>


        {imagePreview && (
          <div className="md:grid md:grid-cols-3 py-2">
            <label htmlFor="agendaImageAlt" className="pr-4">Image Alt</label>
            <div className="w-full col-span-1 col-start-2">
              <input
                type="text"
                name="image_alt"
                id="agendaImageAlt"
                className="w-full border p-2"
              />
            </div>
            {errors.image_alt && (
              <div className="text-red-600 col-span-3">{errors.image_alt}</div>
            )}
          </div>
        )}


        {/* {["doelgroep", "actueel_wijken", "actueel_type"].map((field) => (
          <fieldset key={field} className="py-4 border-0">
            <div className="md:grid md:grid-cols-3">
              <legend className="pr-4 pt-2">{taxonomyLabels[field] || field}</legend>
              <div className="w-full space-y-1 col-span-2">
                {filterOptions[field]?.map((term) => (
                  <label key={term.value} className="flex items-center space-x-2">
                    <input type="checkbox" name={field} value={term.value} className="form-checkbox" />
                    <span>{term.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </fieldset>
        ))} */}


        {["doelgroep", "actueel_wijken", "actueel_type"].map((field) => (
          <fieldset key={field} className="py-4 border-0">
            <div className="md:grid md:grid-cols-3">
              <legend className="pr-4 pt-2 capitalize">
                {field === "actueel_wijken"
                  ? "Wijken"
                  : field === "actueel_type"
                    ? "Type"
                    : field.charAt(0).toUpperCase() + field.slice(1)}
              </legend>

              {/* Checkbox grid */}
              <div className="w-full col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
                {filterOptions[field]?.map((term) => (
                  <label key={term.value} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name={field}
                      value={term.value}
                      className="form-checkbox"
                    />
                    <span>{term.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </fieldset>
        ))}



        {/* Transitieagenda */}
        <div className="md:grid md:grid-cols-3 py-4">
          <label htmlFor="agendaTaxonomy" className="pr-4">Transitieagenda</label>
          <div className="w-full relative col-span-2">
            <select id="agendaTaxonomy" name="transitieagenda" className="w-full border p-2 appearance-none">
              <option value="">Selecteer transitieagenda</option>
              {filterOptions.transitieagenda?.map((term) => (
                <option key={term.value} value={term.value}>{term.label}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Dates */}
        <div className="md:grid md:grid-cols-3 py-4">
          <label className="pr-4">Datum *</label>
          <div className="w-full col-span-2 flex gap-x-10">
            <div className="w-1/2">
              <input type="date" name="start_date" className="w-full border p-2" />
              {errors.start_date && <div className="text-red-600">{errors.start_date}</div>}
            </div>
            <div className="w-1/2">
              <input type="date" name="end_date" className="w-full border p-2" />
              {errors.end_date && <div className="text-red-600">{errors.end_date}</div>}
            </div>
          </div>
        </div>

        {/* Times */}
        <div className="md:grid md:grid-cols-3 py-4">
          <label className="pr-4">Tijd *</label>
          <div className="w-full col-span-2 flex gap-x-10">
            <div className="w-1/2">
              <input type="time" name="start_time" className="w-full border p-2" />
              {errors.start_time && <div className="text-red-600">{errors.start_time}</div>}
            </div>
            <div className="w-1/2">
              <input type="time" name="end_time" className="w-full border p-2" />
              {errors.end_time && <div className="text-red-600">{errors.end_time}</div>}
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="md:grid md:grid-cols-3 pb-4">
          <label htmlFor="extraText" className="pr-4">Locatie *</label>
          <div className="w-full col-span-2">
            <input type="text" name="extra" id="extraText" className="w-full border p-2" />
          </div>
          {errors.location && <div className="text-red-600 col-span-3">{errors.location}</div>}
        </div>

        {/* Submit */}
        <div className="grid grid-cols-3 gap-4 pt-4 items-center">
          <button type="submit" disabled={loading} className="submit-btn border px-6 py-2 rounded-full">
            {loading ? "Versturen..." : "Verstuur"}
          </button>
          {loading && <div className="loader"></div>}
        </div>

        {/* {response && (
          <div className={`pt-4 text-lg ${response.status === "success" ? "text-green-600" : "text-red-600"}`}>
            {response.message}
          </div>
        )} */}

        {response && response.status !== "success" && (
          <div className="pt-4 text-lg text-red-600">
            {response.message}
          </div>
        )}

      </form>

      {
        showSuccessModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center sm:z-[70] lg:z-[60]">
            <div className="relative bg-cirGold px-8 py-12 rounded-md w-full max-w-md">

              <button className="absolute top-5 right-4 transition-opacity duration-300 hover:opacity-60 cursor-pointer"
                onClick={() => setShowSuccessModal(false)}>
                <div className="flex gap-2 items-center">
                  <span className="text-white text-lg scale-text-150:text-xl scale-text-200:text-2xl">Sluiten</span>
                  <img
                    src={_getBaseUrl("src/assets/icons/close-icon.svg", true)}
                    className="invert-0"
                    alt=""
                  />
                </div>
              </button>

              <div className="text-white pt-4">
                <h2 className="pb-0 font-sharpgrotesk font-bold text-[32px]">
                  Formulier verzonden.
                </h2>
                {/* <p
                  className="text-lg scale-text-150:text-xl scale-text-200:text-2xl text-white"
                >
                  Het Contactformulier is succesvol verzonden !
                </p> */}
                {response && response.status == "success" && (
                  <p className="text-lg scale-text-150:text-xl scale-text-200:text-2xl text-white">
                    {response.message}
                  </p>
                )}
              </div>

            </div>
          </div>
        )
      }


    </>


  );
}

export default AgendaForm;
